import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setBasemapNameStore } from 'store/global/map/basemapStyleInfo'
import { ViewMode, DrawPolygonMode, DrawPointMode } from '@nebula.gl/edit-modes'

import Grow from '@material-ui/core/Grow'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import Tooltip from '@material-ui/core/Tooltip'
import { makeStyles } from '@material-ui/core/styles'

import LayersOutlinedIcon from '@material-ui/icons/LayersOutlined'
import DeleteIcon from '@material-ui/icons/Delete'
import CircularProgress from '@material-ui/core/CircularProgress'
import GpsFixedIcon from '@material-ui/icons/GpsFixed'

import Light from '../../../assets/Light.png'
import Dark from '../../../assets/Dark.png'
import Street from '../../../assets/Street.png'
import Outdoors from '../../../assets/Outdoors.png'
import Satelite from '../../../assets/Satelite.png'
import DNI from '../../../assets/DNI.png'
import Wind from '../../../assets/wind.png'
import Slope from '../../../assets/slope.png'
import LogoArea from '../../../assets/shape.png'
import WhiteMarker from '../../../assets/white_marker.png'

import './styleSelector.css'

const useStyles = makeStyles((theme) => ({
  txtContainer: {
    '& label.Mui-focused': {
      color: '#a65e44',
      fontSize: '14px !important',
    },
    '& .MuiOutlinedInput-root': {
      marginLeft: '5px',
      '&:hover fieldset': {
        borderColor: '#a65e44',
        fontSize: '14px !important',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#a65e44',
        fontSize: '14px !important',
      },
    },
    width: '180px',
    alignSelf: 'center',
  },
  txtContainerLoading: {
    '& label.Mui-focused': {
      color: '#a65e44',
      fontSize: '14px !important',
    },
    '& .MuiOutlinedInput-root': {
      color: '#979797',
      marginLeft: '5px',
      '&:hover fieldset': {
        borderColor: '#a65e44',
        fontSize: '14px !important',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#a65e44',
        fontSize: '14px !important',
      },
    },

    backgroundColor: '#e1e1e1',
    fontWeight: 'bold',
    width: '180px',
    alignSelf: 'center',
  },
  circle: {
    color: '#000000',
    opacity: '0.54',
    height: '24px !important',
    width: '24px !important',
    marginLeft: '13px',
    marginTop: '12px',
  },
}))

function StyleSelector(props) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const basemapName = useSelector((state) => state.basemapStyle.basemapStyleName)

  const [toggler, setToggler] = useState(false)
  const [bar, setBar] = useState(false)
  const [wind, setWind] = useState(false)
  const [slope, setSlope] = useState(false)
  const [img, setImg] = useState(Satelite)
  const [polygonBg, setPolygonBg] = useState('')
  const [pointBg, setPointBg] = useState('')

  useEffect(() => {
    if (basemapName.trim() !== '') {
      if (basemapName === 'satelite') setImg(Satelite)
      if (basemapName === 'dark') setImg(Dark)
      if (basemapName === 'light') setImg(Light)
      if (basemapName === 'streets') setImg(Street)
      if (basemapName === 'outdoors') setImg(Outdoors)
      if (basemapName === 'slope') {
        setImg(Slope)
        setSlope(true)
      }
      if (basemapName === 'wind') {
        setImg(Wind)
        setWind(true)
      }
      if (basemapName === 'solar') {
        setImg(DNI)
        setBar(true)
      }
    }
  }, [])

  useEffect(() => {
    if (props.current === 'tools') {
      setPointBg('')
      setPolygonBg('')
      // props.setRasterlbl('')
      props.setSolar(false)
      props.setSolarPolygon(false)
      props.setModeRaster(() => ViewMode)
    }
  }, [props.current])

  const showMenu = () => {
    if (toggler === false) setToggler(true)
    if (toggler === true) setToggler(false)
  }

  const showBar = () => {
    if (bar === false) setBar(true)
    if (bar === true) setBar(false)
  }

  const clearRasters = () => {
    setPointBg('')
    setPolygonBg('')
    props.setRasterlbl('')
    props.setSolar(false)
    props.setSolarPolygon(false)
    props.setFeaturesRaster({
      type: 'FeatureCollection',
      features: [],
    })
  }

  const barColorsSolar = [
    { width: '30px', height: '15px', backgroundColor: '#00f82d' },
    { width: '30px', height: '15px', backgroundColor: '#65f219' },
    { width: '30px', height: '15px', backgroundColor: '#a1f621' },
    { width: '30px', height: '15px', backgroundColor: '#c1fc00' },
    { width: '30px', height: '15px', backgroundColor: '#d9ff00' },
    { width: '30px', height: '15px', backgroundColor: '#ffee00' },
    { width: '30px', height: '15px', backgroundColor: '#ff9a02' },
    { width: '30px', height: '15px', backgroundColor: '#ff2500' },
    { width: '30px', height: '15px', backgroundColor: '#ec1f00' },
    { width: '30px', height: '15px', backgroundColor: '#e00004' },
    { width: '30px', height: '15px', backgroundColor: '#c00003' },
    { width: '30px', height: '15px', backgroundColor: '#8f0002' },
    { width: '30px', height: '15px', backgroundColor: '#490001' },
  ]

  const barColorsSolarCol = [
    { width: '30px', height: '15px', backgroundColor: '#48c15a' },
    { width: '30px', height: '15px', backgroundColor: '#75cf1a' },
    { width: '30px', height: '15px', backgroundColor: '#97da00' },
    // {width:"30px",height:"15px",backgroundColor:"#b3e200"},
    { width: '30px', height: '15px', backgroundColor: '#ceea00' },
    { width: '30px', height: '15px', backgroundColor: '#eaf200' },
    { width: '30px', height: '15px', backgroundColor: '#f5ea00' },
    { width: '30px', height: '15px', backgroundColor: '#f5d800' },
    { width: '30px', height: '15px', backgroundColor: '#f6c600' },
    { width: '30px', height: '15px', backgroundColor: '#f6b400' },
    { width: '30px', height: '15px', backgroundColor: '#f6a200' },
    // {width:"30px",height:"15px",backgroundColor:"#f79000"},
    { width: '30px', height: '15px', backgroundColor: '#f67a00' },
    { width: '30px', height: '15px', backgroundColor: '#ee5200' },
    { width: '30px', height: '15px', backgroundColor: '#de0000' },
  ]

  const barMarkerSolar = [
    { marginLeft: '', width: '2px', height: '5px', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '27.8px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '28px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
  ]

  const barTagsSolar = [
    { marginLeft: '20px', tag: '1680' },
    { marginLeft: '', tag: '1900' },
    { marginLeft: '', tag: '1950' },
    { marginLeft: '', tag: '2000' },
    { marginLeft: '', tag: '2050' },
    { marginLeft: '', tag: '2100' },
    { marginLeft: '', tag: '2150' },
    { marginLeft: '', tag: '2200' },
    { marginLeft: '', tag: '2250' },
    { marginLeft: '', tag: '2300' },
    { marginLeft: '', tag: '2350' },
    { marginLeft: '', tag: '2400' },
    { marginLeft: '', tag: '2410' },
    { marginLeft: '', tag: '2410+' },
  ]

  const barTagsSolarCol = [
    { marginLeft: '20px', tag: '1095' },
    { marginLeft: '', tag: '1179' },
    { marginLeft: '', tag: '1263' },
    { marginLeft: '', tag: '1348' },
    { marginLeft: '', tag: '1432' },
    { marginLeft: '', tag: '1516' },
    { marginLeft: '', tag: '1600' },
    { marginLeft: '', tag: '1685' },
    { marginLeft: '', tag: '1769' },
    { marginLeft: '', tag: '1853' },
    { marginLeft: '', tag: '1937' },
    { marginLeft: '', tag: '2022' },
    { marginLeft: '', tag: '2106' },
    { marginLeft: '', tag: '2190+' },
  ]

  const barTagsSolarChl = [
    { marginLeft: '', tag: '547' },
    { marginLeft: '', tag: '730' },
    { marginLeft: '', tag: '912' },
    { marginLeft: '', tag: '1095' },
    { marginLeft: '', tag: '1277' },
    { marginLeft: '', tag: '1461' },
    { marginLeft: '', tag: '1642' },
    { marginLeft: '', tag: '1826' },
    { marginLeft: '', tag: '2007' },
    { marginLeft: '', tag: '2191' },
    { marginLeft: '', tag: '2372' },
    { marginLeft: '', tag: '2556' },
    { marginLeft: '', tag: '2737' },
    { marginLeft: '', tag: '2920+' },
  ]

  // const barColorsWind = [
  //   { width: '25px', height: '15px', backgroundColor: '#dcda68' },
  //   { width: '25px', height: '15px', backgroundColor: '#dcda45' },
  //   { width: '25px', height: '15px', backgroundColor: '#dbdb23' },
  //   { width: '25px', height: '15px', backgroundColor: '#dbdb01' },
  //   { width: '25px', height: '15px', backgroundColor: '#76be27' },
  //   { width: '25px', height: '15px', backgroundColor: '#339851' },
  //   { width: '25px', height: '15px', backgroundColor: '#256780' },
  //   { width: '25px', height: '15px', backgroundColor: '#1737af' },
  //   { width: '25px', height: '15px', backgroundColor: '#1111d6' },
  //   { width: '25px', height: '15px', backgroundColor: '#2f18de' },
  //   { width: '25px', height: '15px', backgroundColor: '#4c20e5' },
  //   { width: '25px', height: '15px', backgroundColor: '#6928ed' },
  //   { width: '25px', height: '15px', backgroundColor: '#792ce4' },
  //   { width: '25px', height: '15px', backgroundColor: '#501d98' },
  //   { width: '25px', height: '15px', backgroundColor: '#280f4c' },
  //   { width: '25px', height: '15px', backgroundColor: '#000000' },
  // ]

  const barColorsWind = [
    { width: '25px', height: '15px', backgroundColor: '#ffffff' },
    { width: '25px', height: '15px', backgroundColor: '#f9f9ed' },
    { width: '25px', height: '15px', backgroundColor: '#f4f3da' },
    { width: '25px', height: '15px', backgroundColor: '#eeedc8' },
    { width: '25px', height: '15px', backgroundColor: '#e8e6b2' },
    { width: '25px', height: '15px', backgroundColor: '#e2e0a0' },
    { width: '25px', height: '15px', backgroundColor: '#ddda8d' },
    { width: '25px', height: '15px', backgroundColor: '#dcda46' },
    { width: '25px', height: '15px', backgroundColor: '#8ac31f' },
    { width: '25px', height: '15px', backgroundColor: '#2f8960' },
    { width: '25px', height: '15px', backgroundColor: '#205592' },
    { width: '25px', height: '15px', backgroundColor: '#1120c4' },
    { width: '25px', height: '15px', backgroundColor: '#331adf' },
    { width: '25px', height: '15px', backgroundColor: '#6126eb' },
    { width: '25px', height: '15px', backgroundColor: '#3c1671' },
    { width: '25px', height: '15px', backgroundColor: '#000000' },
  ]

  const barMarkerWind = [
    { marginLeft: '', width: '2px', height: '5px', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
    { marginLeft: '22.85px', width: '2px', height: '', backgroundColor: '#c1c1c1' },
  ]

  const barTagsWind = [
    { marginLeft: '26px', tag: '0' },
    { marginLeft: '', tag: '0.6' },
    { marginLeft: '', tag: '1.2' },
    { marginLeft: '', tag: '1.8' },
    { marginLeft: '', tag: '2.5' },
    { marginLeft: '', tag: '3.1' },
    { marginLeft: '', tag: '3.7' },
    { marginLeft: '', tag: '4.3' },
    { marginLeft: '', tag: '5' },
    { marginLeft: '', tag: '5.6' },
    { marginLeft: '', tag: '6.2' },
    { marginLeft: '', tag: '6.8' },
    { marginLeft: '', tag: '7.5' },
    { marginLeft: '', tag: '8.1' },
    { marginLeft: '', tag: '8.7' },
    { marginLeft: '', tag: '9.3' },
    { marginLeft: '', tag: '10+' },
  ]

  //{toggler===false ? <img className='style-cover' src={img} /> : <img className='style-cover' src={img} style={{boxShadow:'0px 0.5px 4px #057eff'}} />}

  return (
    <div>
      {toggler === false ? (
        <div className="style-select" style={{ backgroundImage: `url(${img})` }} onClick={() => showMenu(true)}>
          <div className="styles-tag">
            <LayersOutlinedIcon style={{ fontSize: '15px', alignSelf: 'center' }} />
            <label style={{ fontSize: '11px', fontWeight: 'bold' }}>Layers</label>
          </div>
        </div>
      ) : (
        <div
          className="style-select"
          style={{ backgroundImage: `url(${img})`, borderColor: '#a65e44' }}
          onClick={() => showMenu(true)}
        >
          <div className="styles-tag" style={{ backgroundColor: '#a65e44' }}>
            <LayersOutlinedIcon style={{ fontSize: '15px', color: 'white', alignSelf: 'center' }} />
            <label style={{ fontSize: '11px', fontWeight: 'bold', color: 'white' }}>Layers</label>
          </div>
        </div>
      )}

      <Grow in={toggler}>
        <div className="style-selector">
          {/*<div className='ifr-title'><p className='ifr-title-txt'>Map Styles</p></div>*/}

          <div
            className="style-btn-container"
            onClick={() => {
              props.bitmapToggle(false)
              props.setStyles(props.rasters.solar)
              dispatch(setBasemapNameStore('solar'))
              setImg(DNI)
              showMenu()
              setBar(true)
              setWind(false)
              setSlope(false)
              clearRasters()
            }}
          >
            <img src={DNI} className="style-img" />
            <label className="style-btn-txt">Solar</label>
          </div>
          <div
            className="style-btn-container"
            onClick={() => {
              props.bitmapToggle(false)
              props.setStyles(props.rasters.wind)
              dispatch(setBasemapNameStore('wind'))
              setImg(Wind)
              showMenu()
              setBar(false)
              setWind(true)
              setSlope(false)
              clearRasters()
            }}
          >
            <img src={Wind} className="style-img" />
            <label className="style-btn-txt">Wind</label>
          </div>
          {props.rasters.slope !== null ? (
            <div
              className="style-btn-container"
              onClick={() => {
                props.bitmapToggle(false)
                props.setStyles(props.rasters.slope)
                dispatch(setBasemapNameStore('slope'))
                setImg(Slope)
                showMenu()
                setBar(false)
                setWind(false)
                setSlope(true)
                clearRasters()
              }}
            >
              <img src={Slope} className="style-img" />
              <label className="style-btn-txt">Slope</label>
            </div>
          ) : null}
          <div
            className="style-btn-container"
            onClick={() => {
              props.bitmapToggle(false)
              props.setStyles('mapbox://styles/mapbox/light-v10')
              dispatch(setBasemapNameStore('light'))
              setImg(Light)
              showMenu()
              setBar(false)
              setWind(false)
              setSlope(false)
              clearRasters()
            }}
          >
            <img src={Light} className="style-img" />
            <label className="style-btn-txt"> Light</label>
          </div>
          <div
            className="style-btn-container"
            onClick={() => {
              props.setStyles('mapbox://styles/mapbox/dark-v10')
              dispatch(setBasemapNameStore('dark'))
              setImg(Dark)
              showMenu()
              setBar(false)
              setWind(false)
              setSlope(false)
              props.bitmapToggle(false)
              clearRasters()
            }}
          >
            <img src={Dark} className="style-img" />
            <label className="style-btn-txt"> Dark</label>
          </div>
          <div
            className="style-btn-container"
            onClick={() => {
              props.bitmapToggle(false)
              props.setStyles('mapbox://styles/mapbox/streets-v11')
              dispatch(setBasemapNameStore('streets'))
              setImg(Street)
              showMenu()
              setBar(false)
              setWind(false)
              setSlope(false)
              clearRasters()
            }}
          >
            <img src={Street} className="style-img" />
            <label className="style-btn-txt"> Street</label>
          </div>
          <div
            className="style-btn-container"
            onClick={() => {
              props.bitmapToggle(false)
              props.setStyles('mapbox://styles/mapbox/outdoors-v11')
              dispatch(setBasemapNameStore('outdoors'))
              setImg(Outdoors)
              showMenu()
              setBar(false)
              setWind(false)
              setSlope(false)
              clearRasters()
            }}
          >
            <img src={Outdoors} className="style-img" />
            <label className="style-btn-txt style-txt-od"> Outdoors</label>
          </div>
          <div
            className="style-btn-container"
            onClick={() => {
              props.setStyles('mapbox://styles/rmstycho/cl2rrcjn5003c15lbbt5urwm2')
              dispatch(setBasemapNameStore('satelite'))
              setImg(Satelite)
              showMenu()
              setBar(false)
              setWind(false)
              setSlope(false)
              props.bitmapToggle(true)
              clearRasters()
            }}
          >
            <img src={Satelite} className="style-img" />
            <label className="style-btn-txt"> Satelite</label>
          </div>
        </div>
      </Grow>

      <Grow in={bar}>
        <div>
          <div className="leyend">
            <label className="leyend-title">Global Horizontal Irradiation</label>

            <div className="leyend-bar">
              {props.country === 'mx'
                ? barColorsSolar.map((val) => (
                    <div style={{ width: val.width, height: val.height, backgroundColor: val.backgroundColor }}></div>
                  ))
                : props.country === 'col'
                ? barColorsSolarCol.map((val) => (
                    <div style={{ width: val.width, height: val.height, backgroundColor: val.backgroundColor }}></div>
                  ))
                : props.country === 'ch'
                ? barColorsSolarCol.map((val) => (
                    <div style={{ width: val.width, height: val.height, backgroundColor: val.backgroundColor }}></div>
                  ))
                : null}
            </div>

            <label className="leyend-bar-lbl">
              kWh/m<sup>2</sup>
            </label>

            <div style={{ display: 'flex', width: '390px', marginLeft: '28px' }}>
              {barMarkerSolar.map((val) => (
                <div
                  style={{
                    marginLeft: val.marginLeft,
                    width: val.width,
                    height: val.height,
                    backgroundColor: val.backgroundColor,
                  }}
                ></div>
              ))}
            </div>

            <div style={{ display: 'flex', width: '410px', marginLeft: '23px' }}>
              {props.country === 'mx'
                ? barTagsSolar.map((val) => (
                    <label style={{ marginLeft: val.marginLeft }} className="lbl-scale">
                      {val.tag}
                    </label>
                  ))
                : props.country === 'col'
                ? barTagsSolarCol.map((val) => (
                    <label style={{ marginLeft: val.marginLeft }} className="lbl-scale">
                      {val.tag}
                    </label>
                  ))
                : props.country === 'ch'
                ? barTagsSolarChl.map((val) => (
                    <label style={{ marginLeft: val.marginLeft, marginRight: '11px' }} className="lbl-scale">
                      {val.tag}
                    </label>
                  ))
                : null}
            </div>
          </div>
          <div className="raster-control ">
            <TextField
              id="outlined-basic"
              className={props.rasterLoading ? classes.txtContainer : classes.txtContainerLoading}
              placeholder="Horizontal irradiation..."
              size="small"
              variant="outlined"
              value={props.rasterlbl}
              InputProps={
                !props.rasterLoading
                  ? {
                      startAdornment: (
                        <InputAdornment position="start">
                          <CircularProgress color="disabled" style={{ width: '15px', height: '15px' }} />
                        </InputAdornment>
                      ),
                    }
                  : null
              }
            />
            <Tooltip title="Site" placement="bottom" arrow>
              <button
                className="mode-btn"
                style={{ marginLeft: '15px', backgroundColor: `${pointBg}`, borderRadius: '0px' }}
                onClick={() => {
                  props.setRasterlbl('')
                  setPointBg('#d4d9df')
                  setPolygonBg('')
                  props.setSolar({ state: true, raster: 'solar' })
                  props.setSolarPolygon({ state: false, raster: '' })
                  // props.setDeleteRasters(true)
                  props.setDistance([])

                  props.setFeaturesRaster({
                    type: 'FeatureCollection',
                    features: [],
                  })
                  props.setCurrent('raster')
                  props.setModeRaster(() => DrawPointMode)
                  props.setStyleRaster({
                    lineColor: [40, 40, 40],
                    fillColor: [120, 120, 120, 125],
                    tentativeLineColor: [236, 236, 236],
                    tentativeFillColor: [255, 255, 255, 80],
                    pointType: 'icon',
                    url: WhiteMarker,
                  })
                }}
              >
                <GpsFixedIcon className="icon-align" />
              </button>
            </Tooltip>
            <Tooltip title="Area" placement="bottom" arrow>
              <button
                className="mode-btn"
                style={{ backgroundColor: `${polygonBg}`, borderRadius: '0px' }}
                onClick={() => {
                  props.setRasterlbl('')
                  setPointBg('')
                  setPolygonBg('#d4d9df')
                  props.setSolar({ state: false, raster: '' })
                  props.setSolarPolygon({ state: true, raster: 'solar' })
                  // props.setDeleteFlag(true)
                  // props.setDeleteRasters(true)
                  props.setDistance([])
                  props.setFeaturesRaster({
                    type: 'FeatureCollection',
                    features: [],
                  })

                  props.setCurrent('raster')
                  props.setModeRaster(() => DrawPolygonMode)
                  props.setStyleRaster({
                    lineColor: [40, 40, 40],
                    fillColor: [120, 120, 120, 125],
                    tentativeLineColor: [236, 236, 236],
                    tentativeFillColor: [255, 255, 255, 80],
                    pointType: 'circle',
                    url: null,
                  })
                }}
              >
                <img src={LogoArea} className="icon-align-inf" />
              </button>
            </Tooltip>
            <Tooltip title="Clear" placement="bottom" arrow>
              <button
                className="mode-btn"
                onClick={() => {
                  setPointBg('')
                  setPolygonBg('')
                  props.setRasterlbl('')
                  props.setSolar(false)
                  props.setSolarPolygon(false)
                  // props.setDeleteFlag(true)
                  // props.setDeleteRasters(true)

                  props.setFeaturesRaster({
                    type: 'FeatureCollection',
                    features: [],
                  })
                  props.setDistance([])
                  props.setModeRaster(() => ViewMode)
                }}
              >
                <DeleteIcon className="icon-align" />
              </button>
            </Tooltip>
          </div>
        </div>
      </Grow>

      <Grow in={wind}>
        <div>
          <div className="leyend">
            <label className="leyend-title">Mean Wind Speed 100m</label>

            <div className="leyend-bar-wind">
              {barColorsWind.map((val) => (
                <div style={{ width: val.width, height: val.height, backgroundColor: val.backgroundColor }}></div>
              ))}
            </div>

            <label className="leyend-bar-lbl-wind">m/s</label>

            <div style={{ display: 'flex', width: '400px', marginLeft: '28px' }}>
              {barMarkerWind.map((val) => (
                <div
                  style={{
                    marginLeft: val.marginLeft,
                    width: val.width,
                    height: val.height,
                    backgroundColor: val.backgroundColor,
                  }}
                ></div>
              ))}
            </div>

            <div style={{ display: 'flex' }}>
              {barTagsWind.map((val) => (
                <label className="lbl-scale-wind" style={{ marginLeft: val.marginLeft }}>
                  {val.tag}
                </label>
              ))}
            </div>
          </div>
          <div className="raster-control">
            <TextField
              id="outlined-basic"
              className={props.rasterLoading ? classes.txtContainer : classes.txtContainerLoading}
              placeholder="Mean Wind Speed..."
              size="small"
              variant="outlined"
              value={props.rasterlbl}
              InputProps={
                !props.rasterLoading
                  ? {
                      startAdornment: (
                        <InputAdornment position="start">
                          <CircularProgress color="disabled" style={{ width: '15px', height: '15px' }} />
                        </InputAdornment>
                      ),
                    }
                  : null
              }
            />
            <Tooltip title="Site" placement="bottom" arrow>
              <button
                className="mode-btn"
                style={{ marginLeft: '15px', backgroundColor: `${pointBg}`, borderRadius: '0px' }}
                onClick={() => {
                  props.setRasterlbl('')
                  setPointBg('#d4d9df')
                  setPolygonBg('')
                  // props.setDeleteFlag(true)
                  // props.setDeleteRasters(true)
                  props.setDistance([])
                  props.setSolar({ state: true, raster: 'wind' })
                  props.setSolarPolygon({ state: false, raster: '' })

                  props.setFeaturesRaster({
                    type: 'FeatureCollection',
                    features: [],
                  })
                  props.setCurrent('raster')
                  props.setModeRaster(() => DrawPointMode)
                  props.setStyleRaster({
                    lineColor: [40, 40, 40],
                    fillColor: [120, 120, 120, 125],
                    tentativeLineColor: [236, 236, 236],
                    tentativeFillColor: [255, 255, 255, 80],
                    pointType: 'icon',
                    url: WhiteMarker,
                  })
                }}
              >
                <GpsFixedIcon className="icon-align" />
              </button>
            </Tooltip>
            <Tooltip title="Area" placement="bottom" arrow>
              <button
                className="mode-btn"
                style={{ backgroundColor: `${polygonBg}`, borderRadius: '0px' }}
                onClick={() => {
                  props.setRasterlbl('')
                  setPointBg('')
                  setPolygonBg('#d4d9df')
                  props.setSolar({ state: false, raster: '' })
                  props.setSolarPolygon({ state: true, raster: 'wind' })
                  // props.setDeleteFlag(true)
                  // props.setDeleteRasters(true)

                  props.setDistance([])
                  props.setFeaturesRaster({
                    type: 'FeatureCollection',
                    features: [],
                  })
                  props.setCurrent('raster')
                  props.setModeRaster(() => DrawPolygonMode)
                  props.setStyleRaster({
                    lineColor: [40, 40, 40],
                    fillColor: [120, 120, 120, 125],
                    tentativeLineColor: [236, 236, 236],
                    tentativeFillColor: [255, 255, 255, 80],
                    pointType: 'circle',
                    url: null,
                  })
                }}
              >
                <img src={LogoArea} className="icon-align-inf" />
              </button>
            </Tooltip>
            <Tooltip title="Clear" placement="bottom" arrow>
              <button
                className="mode-btn"
                onClick={() => {
                  setPointBg('')
                  setPolygonBg('')
                  props.setRasterlbl('')
                  props.setSolar(false)
                  props.setSolarPolygon(false)
                  // props.setDeleteRasters(true)

                  props.setFeaturesRaster({
                    type: 'FeatureCollection',
                    features: [],
                  })
                  props.setDistance([])
                  props.setModeRaster(() => ViewMode)
                }}
              >
                <DeleteIcon className="icon-align" />
              </button>
            </Tooltip>
          </div>
        </div>
      </Grow>

      <Grow in={slope}>
        <div>
          <div className="leyend">
            <label className="leyend-title">Slope Degree</label>

            <div className="leyend-bar-wind slopes-gradient"></div>

            <label className="leyend-bar-lbl-wind">deg°</label>

            <div style={{ display: 'flex', width: '400px', marginLeft: '28px' }}>
              <div
                style={{
                  marginLeft: '0px',
                  width: '2px',
                  height: '5px',
                  backgroundColor: '#c1c1c1',
                }}
              ></div>
              <div
                style={{
                  margin: '0 0 0 auto',
                  width: '2px',
                  height: '5px',
                  backgroundColor: '#c1c1c1',
                }}
              ></div>
            </div>

            <div style={{ display: 'flex', width: '400px', marginLeft: '28px' }}>
              <label className="lbl-scale-wind" style={{ marginLeft: '-1.5px' }}>
                0°
              </label>
              <label className="lbl-scale-wind" style={{ margin: '0 -7px 0 auto' }}>
                40°+
              </label>
            </div>
          </div>
          <div className="raster-control">
            <TextField
              id="outlined-basic"
              className={props.rasterLoading ? classes.txtContainer : classes.txtContainerLoading}
              placeholder="Average Slope..."
              size="small"
              variant="outlined"
              value={props.rasterlbl}
              InputProps={
                !props.rasterLoading
                  ? {
                      startAdornment: (
                        <InputAdornment position="start">
                          <CircularProgress color="disabled" style={{ width: '15px', height: '15px' }} />
                        </InputAdornment>
                      ),
                    }
                  : null
              }
            />
            <Tooltip title="Site" placement="bottom" arrow>
              <button
                className="mode-btn"
                style={{ marginLeft: '15px', backgroundColor: `${pointBg}`, borderRadius: '0px' }}
                onClick={() => {
                  props.setRasterlbl('')
                  setPointBg('#d4d9df')
                  setPolygonBg('')
                  // props.setDeleteFlag(true)
                  // props.setDeleteRasters(true)
                  props.setDistance([])
                  props.setSolar({ state: true, raster: 'slope' })
                  props.setSolarPolygon({ state: false, raster: '' })

                  props.setFeaturesRaster({
                    type: 'FeatureCollection',
                    features: [],
                  })
                  props.setCurrent('raster')
                  props.setModeRaster(() => DrawPointMode)
                  props.setStyleRaster({
                    lineColor: [40, 40, 40],
                    fillColor: [120, 120, 120, 125],
                    tentativeLineColor: [236, 236, 236],
                    tentativeFillColor: [255, 255, 255, 80],
                    pointType: 'icon',
                    url: WhiteMarker,
                  })
                }}
              >
                <GpsFixedIcon className="icon-align" />
              </button>
            </Tooltip>
            <Tooltip title="Area" placement="bottom" arrow>
              <button
                className="mode-btn"
                style={{ backgroundColor: `${polygonBg}`, borderRadius: '0px' }}
                onClick={() => {
                  props.setRasterlbl('')
                  setPointBg('')
                  setPolygonBg('#d4d9df')
                  props.setSolar({ state: false, raster: '' })
                  props.setSolarPolygon({ state: true, raster: 'slope' })
                  // props.setDeleteFlag(true)
                  // props.setDeleteRasters(true)

                  props.setDistance([])
                  props.setFeaturesRaster({
                    type: 'FeatureCollection',
                    features: [],
                  })
                  props.setCurrent('raster')
                  props.setModeRaster(() => DrawPolygonMode)
                  props.setStyleRaster({
                    lineColor: [255, 255, 255],
                    fillColor: [255, 255, 255, 125],
                    tentativeLineColor: [236, 236, 236],
                    tentativeFillColor: [255, 255, 255, 80],
                    pointType: 'circle',
                    url: null,
                  })
                }}
              >
                <img src={LogoArea} className="icon-align-inf" />
              </button>
            </Tooltip>
            <Tooltip title="Clear" placement="bottom" arrow>
              <button
                className="mode-btn"
                onClick={() => {
                  setPointBg('')
                  setPolygonBg('')
                  props.setRasterlbl('')
                  props.setSolar(false)
                  props.setSolarPolygon(false)
                  // props.setDeleteRasters(true)

                  props.setFeaturesRaster({
                    type: 'FeatureCollection',
                    features: [],
                  })
                  props.setDistance([])
                  props.setModeRaster(() => ViewMode)
                }}
              >
                <DeleteIcon className="icon-align" />
              </button>
            </Tooltip>
          </div>
        </div>
      </Grow>
    </div>
  )
}

export default StyleSelector
